export default __webpack_public_path__ + "static/media/insurance-logo.b430c09e.svg";